/**
 * Trigger: tr_account_initial_balances_soft_delete
 * Purpose: Update account balances when an initial balance is soft deleted or restored
 * Table: account_initial_balances
 * Event: UPDATE OF is_deleted
 */
export const TR_ACCOUNT_INITIAL_BALANCES_SOFT_DELETE = `
CREATE TRIGGER tr_account_initial_balances_soft_delete
UPDATE OF is_deleted ON account_initial_balances
BEGIN
  UPDATE account_balances
  SET initial_balance = CASE
    WHEN new.is_deleted = 0 THEN old.initial_balance
    ELSE 0
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND new.is_deleted <> old.is_deleted;

  UPDATE account_daily_balances
  SET initial_balance = CASE
    WHEN new.is_deleted = 0 THEN old.initial_balance
    ELSE 0
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.balance_date
    AND new.is_deleted <> old.is_deleted;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
